import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { color } from '../../../app/theme';
import Dropdown from '../../shared/Dropdown';
import Switch from '../../shared/Switch';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 44,
    },
    title: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 15,
      lineHeight: '15px',
      color: color.$3,
      marginBottom: 12,
    },
    input: {
      width: 320,
      backgroundColor: color.$7,
    },
    action: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '418px',
      padding: '12px 16px',
      borderRadius: '24px',
      backgroundColor: color.$19,
    },
  },
  {
    name: 'SuccessTriggerAction',
  },
);

const SuccessTriggerAction = ({ selectCouponList = [], data, onChange }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { enabled, couponSetId } = data || {};

  const onSetCouponSetId = value => {
    onChange({
      couponSetId: value,
    });
  };

  const onSwitchChange = () => {
    onChange({
      enabled: !enabled,
    });
  };

  return (
    <div className={classes.root}>
      <div className={classes.title}>{t('ecBinding:successTriggerAction')}</div>
      <div className={classes.action}>
        <Dropdown
          style={{ width: 320 }}
          placeholder={t('ecBinding:successTriggerAction-placeholder')}
          value={couponSetId || null}
          onChange={onSetCouponSetId}
          menuItems={selectCouponList.map(o => ({
            text: o?.couponName,
            value: o?.couponSetId,
          }))}
        />
        <Switch onChange={onSwitchChange} checked={enabled} />
      </div>
    </div>
  );
};

export default SuccessTriggerAction;
